import { s as src, j as _createClass, k as _classCallCheck, f as _createForOfIteratorHelper } from './index2.js';
import 'tty';
import 'os';
import 'deepmerge';
import 'axios';
import 'vue';
import { fromLatLon } from 'utm';

var log = src('xpedeo-core:FraunhoferPositionEngine');
src.enable(process.env.VUE_APP_DEBUG || '');

var FraunhoferPositionEngine = /*#__PURE__*/function () {
  function FraunhoferPositionEngine() {
    _classCallCheck(this, FraunhoferPositionEngine);

    this.isListening = false;
    this.subscribers = [];
  }

  _createClass(FraunhoferPositionEngine, [{
    key: "getLastPosition",
    value: function getLastPosition() {
      return this.lastPosition;
    }
  }, {
    key: "getIsListening",
    value: function getIsListening() {
      return this.isListening;
    }
  }, {
    key: "getSubscribers",
    value: function getSubscribers() {
      return this.subscribers;
    }
  }, {
    key: "subscribe",
    value: function subscribe(callback) {
      if (!this.subscribers.includes(callback)) {
        this.subscribers.push(callback);
      } else {
        throw new Error('this callback has already subscribed to GpsEngine.');
      }
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe(callback) {
      if (this.subscribers.includes(callback)) {
        this.subscribers = this.subscribers.filter(function (item) {
          return item !== callback;
        });
      } else {
        throw new Error("this callback does not exist in GpsEngine's subscribers.");
      }
    }
  }, {
    key: "start",
    value: function start() {
      log('start listening in FraunhoferPositionEngine'); // replace with Fraunhofer init logic (the method from the plugin to build)

      window.Fraunhofer.start(this.notify.bind(this), this.onError.bind(this)); // this.watcherId = navigator.geolocation.watchPosition(this.parsePositionAndNotify.bind(this));

      this.isListening = true;
      return true;
    }
  }, {
    key: "stop",
    value: function stop() {
      log('stop listening in FraunhoferPositionEngine');
      window.Fraunhofer.stop(function () {
        log('stopped successfully');
      }, this.onError.bind(this)); // replace with Fraunhofer stop logic (the method from the plugin to build)
      // navigator.geolocation.clearWatch(this.watcherId);

      this.isListening = false;
      return true;
    }
  }, {
    key: "notify",
    value: function notify(info) {
      // log(`notify`, info);
      this.lastPosition = info;

      var _iterator = _createForOfIteratorHelper(this.subscribers),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var cb = _step.value;
          cb(info);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "onError",
    value: function onError(error) {
      log('Error has happened.', error);
    }
  }]);

  return FraunhoferPositionEngine;
}();

var log$1 = src('xpedeo-core:GpsEngine');
src.enable(process.env.VUE_APP_DEBUG || '');

var GpsEngine = /*#__PURE__*/function () {
  function GpsEngine() {
    _classCallCheck(this, GpsEngine);

    this.isListening = false;
    this.subscribers = [];
  }

  _createClass(GpsEngine, [{
    key: "getLastPosition",
    value: function getLastPosition() {
      return this.lastGpsPosition;
    }
  }, {
    key: "getIsListening",
    value: function getIsListening() {
      return this.isListening;
    }
  }, {
    key: "getSubscribers",
    value: function getSubscribers() {
      return this.subscribers;
    }
  }, {
    key: "subscribe",
    value: function subscribe(callback) {
      if (!this.subscribers.includes(callback)) {
        this.subscribers.push(callback);
      } else {
        throw new Error('this callback has already subscribed to GpsEngine.');
      }
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe(callback) {
      if (this.subscribers.includes(callback)) {
        this.subscribers = this.subscribers.filter(function (item) {
          return item !== callback;
        });
      } else {
        throw new Error("this callback does not exist in GpsEngine's subscribers.");
      }
    }
  }, {
    key: "start",
    value: function start() {
      log$1('start listening in GpsEngine');
      this.watcherId = navigator.geolocation.watchPosition(this.parsePositionAndNotify.bind(this));
      this.isListening = true;
      return true;
    }
  }, {
    key: "stop",
    value: function stop() {
      log$1('stop listening in GpsEngine');
      navigator.geolocation.clearWatch(this.watcherId);
      this.isListening = false;
      return true;
    }
  }, {
    key: "parsePositionAndNotify",
    value: function parsePositionAndNotify(position) {
      var utmPosition = fromLatLon(position.coords.latitude, position.coords.longitude);
      var info = {
        accuracy: position.coords.accuracy,
        easting: utmPosition.easting,
        height: position.coords.altitude,
        northing: utmPosition.northing,
        quality: -1,
        siteName: null,
        timestamp: position.timestamp
      };
      this.lastGpsPosition = info;
      this.notify(info);
    }
  }, {
    key: "notify",
    value: function notify(info) {
      log$1('notify', info);

      var _iterator = _createForOfIteratorHelper(this.subscribers),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var cb = _step.value;
          cb(info);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }]);

  return GpsEngine;
}();

// const log = debug('xpedeo-core:PseudoEngine')
// debug.enable(process.env.VUE_APP_DEBUG || '')
var PseudoEngine = /*#__PURE__*/function () {
  function PseudoEngine() {
    _classCallCheck(this, PseudoEngine);
  }

  _createClass(PseudoEngine, [{
    key: "getLastPosition",
    value: function getLastPosition() {
      return this.lastPseudoPosition;
    }
  }, {
    key: "setPseudoCoordination",
    value: function setPseudoCoordination(coords) {
      this.lastPseudoPosition = coords;
    }
    /**
     * @depredated
     */

  }, {
    key: "getPseudoCoordination",
    value: function getPseudoCoordination() {
      return this.lastPseudoPosition;
    }
  }, {
    key: "getIsListening",
    value: function getIsListening() {
      return false;
    }
  }, {
    key: "start",
    value: function start() {
      return true;
    }
  }, {
    key: "stop",
    value: function stop() {
      return true;
    }
  }, {
    key: "getSubscribers",
    value: function getSubscribers() {
      return [];
    }
  }, {
    key: "subscribe",
    value: function subscribe(callback) {
      throw new Error('Method not implemented.');
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe(callback) {
      throw new Error('Method not implemented.');
    }
  }, {
    key: "notify",
    value: function notify(info) {
      throw new Error('Method not implemented.');
    }
  }]);

  return PseudoEngine;
}();

var log$2 = src('xpedeo-core:positioning');
src.enable(process.env.VUE_APP_DEBUG || '');
var positioningPlugin = {
  __engines: new Map(),
  getEngine: function getEngine(type) {
    return this.__engines.get(type);
  },
  install: function install(Vue, opts, $xp, cfg) {
    log$2('installing positioning plugin');

    if ($xp.positioningInstalled) {
      return;
    }

    $xp.positioningInstalled = true; // initialize engines based on plugin options

    this.__engines.set("GPS"
    /* GPS */
    , new GpsEngine());

    if (cfg.engines) {
      var _iterator = _createForOfIteratorHelper(cfg.engines),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var engine = _step.value;

          switch (engine) {
            case 'pseudo':
              this.__engines.set("Pseudo"
              /* PSEUDO */
              , new PseudoEngine());

              break;

            case 'FraunhoferPosition':
              this.__engines.set("FraunhoferPosition"
              /* FraunhoferPosition */
              , new FraunhoferPositionEngine());

              break;

            default:
              throw new Error("".concat(engine, " is invalid positioning engine"));
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    Vue.util.defineReactive($xp, 'positioning', this);
  }
};

export default positioningPlugin;
//# sourceMappingURL=positioning.js.map
